import Clipboard from 'clipboard';
import {TvmImageSlider} from "./components/TvmImageSlider";
import "./empty.scss";

(function () {
    // Pegasus.
    (function () {
        // Pegasus.Common.
        (function () {
            // Pegasus.Common.Common
            (function () {
                // Pegasus.Common.Common.Advanced
                (function () {
                    // Pegasus.Common.Common.Advanced.Tvm

                    this.addFancyBox = function(item) {
                        var $item = $(item);

                        if (!$item.hasClass('fancybox.ajax')) {
                            $item.addClass('fancybox.ajax');
                            $item.addClass('no-ext-link-icon');
                            $item.fancybox({
                                autosize: false,
                                width: 1000,
                                padding: 0,
                                href: $item.data('fancybox-href'),
                                title: '',
                                afterShow: function () {
                                    var $closebox = $('.fancybox-close');
                                    if ($(item).hasClass('white')) {
                                        $closebox.addClass('white');
                                    }
                                    new Clipboard('.fancybox-inner .tvm-event .socialbar .copy .link');

                                    $('.fancybox-inner .tvm-event--name-wrapper [href]').focus();

                                    $('body').on('keyup', function(event) {
                                        if(event.keyCode === 27 &&!document.querySelector('.fancybox-inner *:focus')) {
                                            $closebox.click();
                                        }
                                    });
                                }
                            });

                            $item.each(function(index, item) {
                                if($(item).find('img').length > 0) {
                                    $(item).attr('tabindex', -1);
                                }
                            });
                        }
                    };

                }).call(this.Tvm || (this.Tvm = {}));
            }).call(this.Advanced || (this.Advanced = {}));
        }).call(this.Common || (this.Common = {}));
    }).call(this.Common || (this.Common = {}));
}).call(window.Pegasus || (window.Pegasus = {}));

$(function () {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            for (var i = 0; i < mutation.addedNodes.length; i++) {

                const $addedNode = $(mutation.addedNodes[i]);
                const $target = $addedNode.find(".tvm-event__image-slider-container");

                if ($target !== null && $target.length) {
                    new TvmImageSlider($target);
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    $(".tvm-event__image-slider-container").each(function () {
        new TvmImageSlider($(this));
    });
});
